import React from "react";
import {getStatusMetadata} from "../api/OrderStatusUtil.tsx";
import Tooltip from "./Tooltip.tsx";

interface StatusBadgeProps {
    statusId: number;
    statusCode: string;
    size?: "default" | "small";
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({
                                                            statusId,
                                                            statusCode,
                                                            size = "default",
                                                        }) => {
    if (!statusId) {
        return null;
    }

    // Get the appropriate metadata for this indicator
    const metadata = getStatusMetadata(statusId);

    // Determine width based on size prop
    const widthClass = size === "small" ? "w-auto" : "w-full";

    return (
        <div className={`relative group ${widthClass}`}>
            <Tooltip text={statusCode}>
                <span
                    className={`flex items-center gap-1.5 px-2.5 py-1.5 rounded-md text-xs font-medium ${metadata.bgColor} ${metadata.textColor} ${widthClass}`}
                >
                    <span className={`${metadata.iconColor} w-5 flex-shrink-0 flex`}>
                        {metadata.icon}
                    </span>
                    <span className="whitespace-normal break-words">{statusCode}</span>
                </span>
            </Tooltip>
        </div>
    );
};